// @flow

import Resource from 'speed-js-core/src/api/NestedResource';
import type { UUID } from 'esm-web-pro/types/common';

export default class CableGEOResource extends Resource {
    basePath: string = 'networks/maps/{parent}/cable/geo/';

    objectPath: string = 'networks/maps/{parent}/cable/geo/{ident}/';

    /**
     * @param {string} mapUUID  UUID of the map
     * @param {object} data contains only pipes UUID that the cable goes through
     * @returns {Promise<Object>} if the cable has eit export or not
     */
    checkEITExport(mapUUID: UUID, data: { pipes: UUID }): Promise<Object> {
        return this.client._request(
            // $FlowFixMe
            `${this._getBasePath(mapUUID)}check_eit_export/`,
            'POST',
            data,
        ).then((response) => response.data);
    }
}
